import React from "react";
import { FormSection } from "@duosoftbg/nacid-components";
import { ContactAddressFormFields } from "@duosoftbg/nacid-frontoffice-components";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { countriesDataThunk } from "../../../../../../store/redux/slice/AppData/countriesData";
import { getSettlement, getSettlementsAutocomplete } from "../../../../../../axios/api/services";

const ContactAddressFormSection = () => {
  const thunkStateCountries = useAppSelector((state) => {
    return state.AppData.countriesData;
  });

  return (
    <FormSection label={"t.contactAddress.details.default"}>
      <ContactAddressFormFields
        requiredFormFields={false}
        countriesThunk={countriesDataThunk}
        countriesThunkState={thunkStateCountries}
        getSettlementsAutocomplete={getSettlementsAutocomplete}
        getSettlement={getSettlement}
      />
    </FormSection>
  );
};
export default ContactAddressFormSection;
